import { Benefits } from '../models/benefits.interfaces';
import {
  Delta360,
  DiamondMedallion,
  GoldMedallion,
  PlatinumMedallion,
  SilverMedallion,
  SkyMiles
} from './goodie.mocks';

export const StandardBenefitsMocks: Benefits = {
  title: 'Your SkyMiles Benefits',
  stacks: [
    {
      title: 'As a <span>SkyMiles Member</span> you earn:',
      ariaLabels: {
        banner: 'SkyMiles Medallion Banner',
        peekBar: 'Silver Medallion Bar'
      },
      tier: 'skymiles',
      current: true,
      goodies: SkyMiles
    },
    {
      title: 'As a <span>Silver Medallion Member</span> you earn:',
      ariaLabels: {
        banner: 'Silver Medallion Banner',
        peekBar: 'Gold Medallion Bar'
      },
      tier: 'silver',
      current: false,
      goodies: SilverMedallion
    },
    {
      title: 'As a <span>Gold Medallion Member</span> you earn:',
      ariaLabels: {
        banner: 'Gold Medallion Banner',
        peekBar: 'Platinum Medallion Bar'
      },
      tier: 'gold',
      current: false,
      goodies: GoldMedallion
    },
    {
      title: 'As a <span>Platinum Medallion Member</span> you earn:',
      ariaLabels: {
        banner: 'Platinum Medallion Banner',
        peekBar: 'Diamond Medallion Bar'
      },
      tier: 'platinum',
      current: false,
      goodies: PlatinumMedallion
    },
    {
      title: 'As a <span>Diamond Medallion Member</span> you earn:',
      ariaLabels: {
        banner: 'Diamond Medallion Banner',
        peekBar: ''
      },
      tier: 'diamond',
      current: false,
      goodies: DiamondMedallion
    }
  ],
  actions: {
    next: 'Next Tier Benefits',
    previous: 'Previous Tier Benefits'
  },
  disabled: false,
  loaded: true
};

export const Delta360BenefitsMocks: Benefits = {
  title: 'Your SkyMiles Benefits',
  stacks: [
    {
      title: 'As a <span>Delta 360˚ Member</span> you earn:',
      ariaLabels: {
        banner: 'Delta 360&deg Medallion Banner',
        peekBar: ''
      },
      tier: '360',
      current: false,
      goodies: Delta360
    }
  ],
  actions: {
    next: 'Next Tier Benefits',
    previous: 'Previous Tier Benefits'
  },
  disabled: false,
  loaded: true
};
